export default "__VITE_ASSET__BsRsBUoC__"